import {BasicSymbol, SymbolStates} from "./BasicSymbol";
import {Reel} from "../Reel";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {XwaysHoarder2GameAssets} from "../../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../../utils/SpineGSAPWrapper";
import {SimpleReelModelSymbolPosition} from "../../../core/reel/simplereel/SimpleReelModel";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";


export class XNudgeSymbol extends BasicSymbol {

    public nudgeDirectionDown: boolean;
    private mpTextContainer: PIXI.Container;
    private mpText: PIXI.BitmapText | null;
    private mpTextWhite: PIXI.BitmapText | null;
    private wildSpine: PIXI.spine.Spine;
    private symTl: gsap.core.Timeline;

    constructor(symbolName: string, initState: SymbolStates, reel: Reel, symbolPosition: SimpleReelModelSymbolPosition) {
        super(symbolName, initState, reel, symbolPosition);
        this.load();
        this.getStateAnimation(initState);
        this.symTl = gsap.timeline();

    }

    public getStateAnimation(state: SymbolStates): gsap.core.Timeline {
        let tl: gsap.core.Timeline = gsap.timeline();
        switch (state) {
            case SymbolStates.SPIN:
                tl.add(() => {
                    this.state = state;
                    this.setSpriteTexture("_spin");
                    this.moveToNormalLayer();
                }, 0);
                break;
            case SymbolStates.START_SPIN:
                tl.add(() => {
                    this.state = state;
                    this.mainSpine!.visible = false;
                }, 0);
                this.moveToNormalLayer();
                break;
            case SymbolStates.LANDING:
                tl.add(() => {
                    this.state = state;
                }, 0);
                if (this.symTl.isActive()) {
                    this.symTl.totalProgress(1);
                }
                tl.add(this.playLandingAnimation());
                if (!this.reel.xnLandSoundPlayed) {
                    tl.add(() => {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XSPLIT_NUDGE_LAND);
                    }, "<");
                    this.reel.xnLandSoundPlayed = true;
                }
                this.symTl = tl;
                break;
            case SymbolStates.NO_WIN:
                tl.add(() => this.moveToNormalLayer());
                break;
            case SymbolStates.WIN:
                tl = super.getStateAnimation(state);
                break;
            case SymbolStates.REVEAL:
                tl.add(() => {
                    this.state = state;
                }, 0);
                tl.add(this.symbolConversionAnimation(), 0);
                break;
            case SymbolStates.STICKY:
                break;
            case SymbolStates.UNSTICKY:
                break;
            case SymbolStates.WIN_TOGGLE:
                break;
            case SymbolStates.REMOVED:
                tl.add(() => {
                    this.state;
                    this.mainSprite.alpha = 0;
                    this.mainSpine!.alpha = 0;
                }, 0);

                break;
            case SymbolStates.SPLIT: //only change sprite states
                tl.add(() => {
                    this.state = state;
                });
                tl.add(this.showSplitAnim());
                break;
            case SymbolStates.START_SPLIT:
                tl.add(() => {
                    this.state = state;
                }, 0);
                tl.add(this.startSplitAnimation(), 0);
                tl.add(this.symbolConversionAnimation());
                break;
            case SymbolStates.SCALED:
                break;
            case SymbolStates.NUDGE:
                if (this.symTl.isActive()) {
                    this.symTl.totalProgress(1);
                }
                tl.add(() => {
                    this.state = state;
                });
                tl.add(this.nudgeAnimation());
                this.symTl = tl;
                break;
            default:
                tl.add(() => {
                    this.state = state;
                }, 0);
                this.moveToNormalLayer();
        }
        return tl;
    }

    public moveSpineAnimation(stepsToGo: number, directionDown: boolean): gsap.core.Timeline {
        const moveTl: gsap.core.Timeline = gsap.timeline();
        const yPosInitial: number = this.mainSpine!.position.y;
        const yPosFinal: number = this.mainSpine!.position.y + stepsToGo * XwaysHoarder2Statics.symbolHeight * (directionDown ? 1 : -1);
        if (this.symID === XwaysHoarder2.model.xnOrginalPos[this.reel.id]) {
            moveTl.to(this, {duration: 0.0001});
            moveTl.to(this.mainSpine!.position, {
                duration: 4 / 30,
                y: yPosInitial + 20 * (directionDown ? -1 : 1)
            });
            moveTl.to(this.mainSpine!.position, {
                duration: 6 / 30,
                y: yPosFinal + 20 * (directionDown ? 1 : -1)
            });
            moveTl.to(this.mainSpine!.position, {
                duration: 2 / 30,
                y: yPosFinal
            });
        }
        return moveTl;
    }

    public blueArrowHighlight(): gsap.core.Timeline {
        const arrowTl: gsap.core.Timeline = gsap.timeline();
        const blueArrow: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.XSPLIT_ARROW));

        blueArrow.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, 0);
        blueArrow.alpha = 0;
        let directionUp: boolean = false;
        if (XwaysHoarder2.model.xnOrginalPos[this.reel.id] === 0 && XwaysHoarder2.model.xnHeight[this.reel.id] === 1) {
            blueArrow.position.y = 250;
            blueArrow.rotation = -1.57;
            directionUp = false;
        } else if (XwaysHoarder2.model.xnOrginalPos[this.reel.id] === 0 && XwaysHoarder2.model.xnHeight[this.reel.id] === 2) {
            blueArrow.position.y = 450;
            blueArrow.rotation = -1.57;
            directionUp = false;
        } else if (XwaysHoarder2.model.xnOrginalPos[this.reel.id] === 1 && XwaysHoarder2.model.xnHeight[this.reel.id] === 2) {
            blueArrow.position.y = 150;
            blueArrow.rotation = 1.57;
            directionUp = true;
        } else if (XwaysHoarder2.model.xnOrginalPos[this.reel.id] === 2 && XwaysHoarder2.model.xnHeight[this.reel.id] === 1) {
            blueArrow.position.y = 350;
            blueArrow.rotation = 1.57;
            directionUp = true;
        }
        arrowTl.add(() => {
            this.reel.layers.overlay.addChild(blueArrow);
        });

        if (XwaysHoarder2.model.xnHeight[this.reel.id] !== 3 && XwaysHoarder2.model.xnHeight[this.reel.id] > 0) {
            arrowTl.to(blueArrow, {alpha: 1, duration: 0.005}, 0);
            arrowTl.add(SpineGSAPWrapper.createTimelineForAnimation(blueArrow, 0, "splitArrow", false));
            arrowTl.to(blueArrow, {alpha: 0, duration: 0.1});
        }

        arrowTl.add(() => {
            this.reel.layers.overlay.removeChild(blueArrow);
        })

        return arrowTl;
    }

    private load() {

        this.mpTextContainer = new PIXI.Container();
        this.mpTextContainer.name = "multipliercontainer";

        this.mainSprite.texture = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.getSymbolStateTexturePath(this.symbolName, ""))[0]).texture;
        this.mainSprite.name = "mainSprite";
        this.mainSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.mainSprite.anchor.set(0.5, 0.5);


        this.mpText = new PIXI.BitmapText("", {
            fontName: XwaysHoarder2GameAssets.NUMBERS_MULTIPLIER,
            fontSize: 32,
        });
        this.mpText.alpha = 0;
        this.mpText.anchor = new PIXI.Point(0.5, 0.5);
        this.mpText.position.set(XwaysHoarder2Statics.symbolWidth - this.mpText.textWidth / 2, XwaysHoarder2Statics.symbolHeight - this.mpText.textHeight);

        this.mpTextWhite = new PIXI.BitmapText("", {
            fontName: XwaysHoarder2GameAssets.MULTIPLIER_WHITE,
            fontSize: 32
        });
        this.mpTextWhite.anchor = new PIXI.Point(0.5, 0.5);
        this.mpTextWhite.alpha = 0;
        this.mpTextWhite.position.set(0, 0);
        this.mpText.addChild(this.mpTextWhite);
        this.mpTextContainer.addChild(this.mpText);

        this.mainSpriteContainer.addChild(this.mainSprite);
        this.setSpine();
        this.view.addChild(this.overlayContainer);
        this.view.addChild(this.mpTextContainer);

        this.visualHeightStatus = 200;
        this.isSticky = false;
        this.isOldSym = false; //doesnt matter in restore
        this.symbolHeight = XwaysHoarder2.model.xnHeight[this.reel.id] !== -1 ? XwaysHoarder2.model.xnHeight[this.reel.id] : 1;//no of space it fills in terms of symbol count in a reel
        this.splitAnimOn = false;
        this.isSplitted = false;
        this.symbolSize = 1;//multiplier counter
        this.noWinOverlay = null; //create according to size
        this.nudgeDirectionDown = this.symbolHeight + this.symID < 3;

    }

    private setSpine(): void {
        this.mainSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.XSPLIT_NUDGE));
        this.mainSpine.visible = false;
        this.mainSpine.name = "mainSpine";
        this.mainSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.view.addChild(this.mainSpine);

        this.wildSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.WILD));
        this.wildSpine.alpha = 0;
        this.wildSpine.name = "wildSpine";
        this.wildSpine.state.setAnimation(0,"w_Idle",false);
        this.wildSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.view.addChild(this.wildSpine);

    }

    private startSplitAnimation(): gsap.core.Timeline {
        const startsplitTL: gsap.core.Timeline = gsap.timeline();
        if (this.symID === XwaysHoarder2.model.xnOrginalPos[this.reel.id]) {
            startsplitTL.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "XN_Split", false), 0);
        } else {
            startsplitTL.to(this, {duration: SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, "XN_Split")});
        }
        return startsplitTL;
    }

    private playLandingAnimation(): gsap.core.Timeline {
        const landingTl: gsap.core.Timeline = gsap.timeline();

        landingTl.to(this.mainSprite, {alpha: 0, duration: 0.0001});
        if (this.symID === XwaysHoarder2.model.xnOrginalPos[this.reel.id]) {//only spine work in this
            if (this.symID === 0) {
                this.mainSpine!.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, 300 + (this.symbolHeight - 3) * XwaysHoarder2Statics.symbolHeight);
            } else {
                this.mainSpine!.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, 300);
            }
            landingTl.add(() => {
                this.mainSpine!.visible = true;
            }, 0);

            landingTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "XN_Land", false), 0);
            landingTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "XN_Idle1", false));
        } else {
            landingTl.to(this, {duration: SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, "XN_Land")});
        }

        landingTl.add(() => {
            this.setSpriteTexture("");
        }, ">");

        return landingTl;

    }

    private nudgeAnimation(): gsap.core.Timeline {
        const nudgeTl: gsap.core.Timeline = gsap.timeline();
        //nudgeTl.to(this.mainSprite, {alpha: 0, duration: 0.0001});
        if (this.symID === XwaysHoarder2.model.xnOrginalPos[this.reel.id]) {//only spine work in this
            nudgeTl.add(() => {
            }, 0);
            nudgeTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "XN_MoveTransform", false));
        } else {
            nudgeTl.to(this, {duration: SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, "XN_MoveTransform")});
            nudgeTl.add(() => {
                this.getStateAnimation(SymbolStates.REMOVED);
                this.moveToOverlayLayer();
            }, 0);
        }
        // nudgeTl.to(this.mainSprite, {alpha: 1, duration: 0.0001});
        return nudgeTl;
    }

    private symbolConversionAnimation(): gsap.core.Timeline {
        const convertTl: gsap.core.Timeline = gsap.timeline();
        //convertTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.wildSpine, 0, "w_Idle", false), 0);
        if (this.symID === XwaysHoarder2.model.xnOrginalPos[this.reel.id]) {
            convertTl.add(() => {
                this.moveToNormalLayer();
            }, 0);
            convertTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "XN_Transform", false), 0);
        } else {
            convertTl.add(() => {
                this.moveToNormalOverLayer();
            }, 0);
            convertTl.to(this, {duration: SpineGSAPWrapper.animationTimeDuration(this.mainSpine!, "XN_Transform")}, 0);
        }
        convertTl.to(this.wildSpine, {alpha: 1, duration: 0.005});
        convertTl.to(this.mainSpine!, {alpha: 0, duration: 0.005}, "<");
        convertTl.add(() => {
            this.moveToNormalLayer();
        }, convertTl.duration());


        return convertTl;
    }

    private showSplitAnim(): gsap.core.Timeline {
        const symSplitTl: gsap.core.Timeline = gsap.timeline();
        this.isSplitted = true;
        symSplitTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.wildSpine, 0, "w_Split",false), 0);
        symSplitTl.add(this.multiplierUpdateAnimation(), "<");
        return symSplitTl;
    }

    private multiplierUpdateAnimation(): gsap.core.Timeline {
        const multiUpdateTl: gsap.core.Timeline = gsap.timeline();
        multiUpdateTl.add(() => {
            this.mpText!.alpha = 1;
        }, 0);
        multiUpdateTl.to(this.mpText!.scale, {x: 0.9, y: 0.9, duration: 0.333}, 0);
        multiUpdateTl.to(this.mpText!.scale, {x: 1.4, y: 1.4, duration: 0.033});
        multiUpdateTl.addLabel("showWhiteFont");
        multiUpdateTl.to(this.mpTextWhite, {alpha: 1, duration: 0.00001}, "showWhiteFont");
        multiUpdateTl.to(this.mpTextWhite!, {alpha: 0, duration: 0.165}, ">");
        multiUpdateTl.to([this.mpText!.scale, this.mpTextWhite!.scale], {
            x: 0.9,
            y: 0.9,
            duration: 0.132
        }, "showWhiteFont");
        multiUpdateTl.to([this.mpText!.scale, this.mpTextWhite!.scale], {x: 1, y: 1, duration: 0.033},">");

        multiUpdateTl.add(() => {
            this.symbolSize = this.symbolSize * 2;
            this.mpText!.text = `${this.symbolSize}x`;
            this.mpTextWhite!.text = `${this.symbolSize}x`;
            this.mpText!.anchor = new PIXI.Point(0.5, 0.5);
            this.mpText!.position.set(XwaysHoarder2Statics.symbolWidth - this.mpText!.textWidth, XwaysHoarder2Statics.symbolHeight - this.mpText!.textHeight);
            this.mpTextWhite!.position.set(0, 0);
            this.mpTextContainer.addChild(this.mpText!);
        }, "showWhiteFont");
        return multiUpdateTl;
    }
}